module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " de " + _vm._s(_vm.descricaoProcesso[_vm.processo]) + " " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), ((!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id))) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }]
  }, [((_vm.processo === 'PAGAMENTO') && _vm._.includes(['Autorização', 'Liquidação'], _vm.ultimaTarefaFeita.nome)) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>611 - Comprovante de Pagamento (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(611)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 611\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id))) ? _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.tela),
      expression: "!loading.tela"
    }]
  }, [(_vm._.has(_vm.analiseTributaria, 'nf') && ('' + _vm.analiseTributaria.nf.SitNfc === '2') && !(('' + _vm.nota.forma_pagamento) === '3' && ('' + _vm.nota.dados_bancarios.banco + _vm.nota.dados_bancarios.agencia + _vm.nota.dados_bancarios.conta).length < 6)) ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>200 - Comunicado Interno (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(200)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 200\n        ")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>219 - Adiantamentos (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 219\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>222 - Extrato de Projeto (PDF)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(222)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 222\n        ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)",
      "title": '<h5>248 - Monitoramento Administrativo</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 248\n        ")]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'ENTIDADE' && _vm.etapa !== 'Solicitação') ? _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "title": '<h5>Faz o download de todos os arquivos da solicitação (zip)</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onDownloadZIP()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(" Baixar arquivos")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm._.isNull(_vm.ehNFe) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>' + (_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) ? 'Ao Concluir esta solicitação será encaminhada para Análise da Fundação BB' : (_vm.aprovacao.resultadoAprovacao ? 'Será encaminhado para ' + _vm.aprovacao.resultadoAprovacao : 'Aguardando decisão (aprovar, devolver, etc)')) + '</h5>'
    }
  }, [(_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) ? _c('button', {
    staticClass: "success",
    attrs: {
      "id": "botao_concluir",
      "disabled": _vm.botao_concluir_disabled || (!_vm.aprovacao.resultadoAprovacao),
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.concluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]) : _c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.concluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1) : _vm._e(), _vm._v(" "), (!_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela && !_vm.loading.cronograma && !_vm._.isEmpty(_vm.projeto) && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>Salva esta solicitação<br/>Para encaminhá-la deve-se usar o botão de Concluir' + (_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.poderes.codigo !== 'DIRIGENTE_SEM_RESTRICAO' ? '<br/>Somente dirigentes estão habilitados para concluir solicitações' : (_vm.poderes.mensagem.length > 0 ? '<br/>Restrições:<br/>' + _vm._.join(_vm.poderes.mensagem, ', ') : '')) + '</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao && _vm.restricaoParaInicializar.length === 0 && (_vm.etapa === 'Solicitação' || _vm.etapa === 'Revisão') && !_vm._.isEmpty(_vm.projeto)) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5> Abrir Chamado referente a solicitação atual</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.abrirChamado($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa  fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Abrir Chamado")])], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: (_vm._.isNull(_vm.id) ? 'Solicitações' : 'Validação'),
        href: '#'
      }, {
        text: _vm.descricaoProcesso[_vm.processo],
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm._.isEmpty(_vm.projeto) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaProjetos"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    class: _vm.ehVisualizacao ? 'fa fa-caret-right' : 'fa fa-pencil',
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Selecione o projeto")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listaProjetos.length === 0),
      expression: "listaProjetos.length === 0"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selecionaProjeto()
      }]
    }
  }, _vm._l((_vm.listaProjetos), function(projetoDisponivel) {
    return _c('option', {
      domProps: {
        "value": projetoDisponivel
      }
    }, [_vm._v(_vm._s(projetoDisponivel.Projeto))])
  }), 0)])])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.projeto) || !_vm._.isNull(_vm.id)) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "solicitacao"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), (!_vm._.isEmpty(_vm.chamado) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("* Atenção: O processo que será analisado possui " + _vm._s(_vm.chamado.length > 1 ? 'chamados vinculados' : 'chamado vinculado') + ": ")]), _vm._v(" "), _vm._l((_vm.chamado), function(c, index) {
    return _c('span', [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          placement: 'top',
          interactive: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', interactive:true}"
      }],
      staticClass: "text-bold",
      attrs: {
        "title": '<h5 class=\'text-left\'>Chamado SGP <span class=\'realce\'>' + c.id + '</span><br/>' + ((c.descricao).substr(0, 200) + (c.descricao.length > 200 ? '...' : '')) + '</h5>'
      }
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": {
          name: 'cadastro-chamado-edita',
          params: {
            id: c.id
          }
        }
      }
    }, [_vm._v(_vm._s(c.id))])], 1), _vm._v("\n                            " + _vm._s(index < _vm.chamado.length - 1 ? ', ' : '') + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.nota.suporteFbb.length > 0 && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('p', [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("** Atenção: Este processo possui " + _vm._s(_vm.nota.suporteFbb.length > 1 ? 'os seguintes suportes vinculados' : 'este suportes vinculado') + ":")]), _vm._v(" "), _vm._l((_vm.nota.suporteFbb), function(suporte, index) {
    return _c('a', {
      staticClass: "text-bold",
      attrs: {
        "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(suporte.numero) + _vm._s(index < _vm.nota.suporteFbb.length - 1 ? ', ' : '') + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              " + _vm._s(_vm.projeto.Projeto) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("\n                ("), _c('strong', [_vm._v(_vm._s(_vm.projeto.Status_ERP))]), _vm._v(")\n                "), _c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'small',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'small', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para a página do Projeto</h5>',
      "to": {
        name: 'projeto',
        params: {
          numero: _vm.projeto.Numero_projeto
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" "), _c('i', {
    staticClass: "fa fa-external-link"
  })]), _c('p')], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [((_vm._.filter(_vm.restricaoParaConcluir, function(erro) {
    return (erro.tag).indexOf('valoresTotaisIncorretosProjeto') !== -1
  })).length > 0) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm._.filter(_vm.restricaoParaConcluir, function(erro) {
    return (erro.tag).indexOf('valoresTotaisIncorretosProjeto') !== -1
  })), function(restricao) {
    return _c('p', [_vm._v(_vm._s(restricao.mensagem) + " "), _c('span', {
      staticClass: "font-italic font-light"
    }, [_vm._v("(" + _vm._s((restricao.tag).substr(-7)) + ")")])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && (_vm._.filter(_vm.restricaoParaConcluir, ['tag', 'adiantamentoNaoDisponivelParaPrestarContas'])).length > 0) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("Ainda não há título de adiantamento disponível para prestar contas")])]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length > 0) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.restricaoParaInicializar), function(restricao) {
    return _c('p', [_vm._v(_vm._s(restricao))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.ultimaTarefaFeita, 'observacao') && !_vm._.isNull(_vm.ultimaTarefaFeita.observacao)) ? _c('div', {
    staticClass: "alert alert-info alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.ultimaTarefaFeita.observacao))])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS', 'PAGAMENTO', 'ADIANTAMENTO', 'RESSARCIMENTO', 'CONTRAPARTIDA'], _vm.processo) && _vm._.includes(['Solicitação'], _vm.etapa) && _vm.projetoComAlteracaoEmAndamento) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("Solicitação não disponível. Verificamos que há uma alteração de projetos em andamento.")])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PRESTACAO_DE_CONTAS'], _vm.processo) && _vm.ehVoluntariado && _vm.etapa === 'Análise') ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.show.info = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', [_vm._v("Projeto de Voluntariado com processo simplificado - após a conclusão da análise, a tarefa será finalizada.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.projeto.data_inicial_formatada) + " a " + _vm._s(_vm.projeto.data_final_formatada))])])]), _vm._v(" "), (!_vm._.includes(['Solicitação'], _vm.etapa)) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome da entidade")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', {
    staticClass: "form-control-static"
  }, [_c('router-link', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "title": '<h5>Ir para o Cadastro dessa Entidade</h5>',
      "to": {
        name: 'cadastro-entidade-visualiza',
        params: {
          id: _vm.projeto.fk_entidade
        }
      },
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.razaoSocial) + "  "), _c('i', {
    staticClass: "fa fa-external-link"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("cnpj")(_vm.entidade.ds_cnpj)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Projeto Superior:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.projetoSuperior))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    on: {
      "click": function($event) {
        _vm.mostrar_representantes = !_vm.mostrar_representantes
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar_representantes ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Representantes Legais:")]), _vm._v(" "), (_vm.mostrar_representantes) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Representante Legal da Entidade (que assina pela entidade e tem mandato vigente)")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.dirigentes), function(dirigente) {
    return (dirigente.bt_ativo && dirigente.bt_assinatura_entidade) ? _c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(dirigente.ds_nome))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm.cargos[dirigente.fk_cargo_mandato]))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(dirigente.dt_fim_mandato, "L")))])]) : _vm._e()
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    on: {
      "click": function($event) {
        _vm.mostrar_ocorrencias = !_vm.mostrar_ocorrencias
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar_ocorrencias ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocorrências:")]), _vm._v(" "), (_vm.temOcorrencia) ? _c('div', [(_vm.mostrar_ocorrencias) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.ocorrencias), function(ocorrencia) {
    return _c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.codigo) + " " + _vm._s(ocorrencia.descricao))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("moment")(ocorrencia.inicio, "L")))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.observacao))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(ocorrencia.etapa))])])
  }), 0)])])])]) : _vm._e()]) : _c('div', [_vm._m(8)])])])]) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("É uma NF-e?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ehNFe),
      expression: "ehNFe"
    }],
    attrs: {
      "type": "radio",
      "name": "ehNfe",
      "disabled": !_vm._.includes(['Solicitação', 'Análise'], _vm.etapa) || _vm.ehVisualizacao
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.ehNFe, true)
    },
    on: {
      "change": function($event) {
        _vm.ehNFe = true
      }
    }
  }), _vm._v(" Sim\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ehNFe),
      expression: "ehNFe"
    }],
    attrs: {
      "type": "radio",
      "name": "ehNfe",
      "disabled": !_vm._.includes(['Solicitação', 'Análise'], _vm.etapa) || _vm.ehVisualizacao
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.ehNFe, false)
    },
    on: {
      "change": function($event) {
        _vm.ehNFe = false
      }
    }
  }), _vm._v(" Não\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.ehNFe) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('chave de acesso')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Chave de Acesso da NF-e:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nfe.chaveAcesso),
      expression: "nfe.chaveAcesso"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:44|max:44'),
      expression: "'required|min:44|max:44'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "chave de acesso",
      "id": "chave de acesso",
      "type": "text",
      "maxlength": "80",
      "disabled": _vm.loading.tela || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nfe.chaveAcesso)
    },
    on: {
      "keyup": _vm.validarChaveNFe,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nfe, "chaveAcesso", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('chave de acesso')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('chave de acesso')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(_vm._.has(_vm.nfe.protocoloValidacao, 'infProt') && !_vm._.isNull(_vm.nfe.protocoloValidacao.infProt)) ? _c('div', {
    class: _vm.nfe.protocoloValidacao.infProt.cStat === '100' ? 'text-green' : 'text-red'
  }, [_vm._v(" Protocolo nº " + _vm._s(_vm.nfe.protocoloValidacao.infProt.nProt) + ", " + _vm._s(_vm.nfe.protocoloValidacao.infProt.xMotivo) + " em " + _vm._s(_vm._f("moment")(_vm.nfe.protocoloValidacao.infProt.dhRecbto, 'DD/MM/YYYY HH:MM')))]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.ehNFe)) ? _c('div', [(_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || (_vm.processo === 'CONTRAPARTIDA' && _vm.ehNFe)) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    class: (_vm.processo !== 'RESSARCIMENTO' ? 'required-field' : '') + (_vm.errors.first('número da nota') ? ' has-error' : '')
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Número do Documento:\n                          "), (_vm.processo === 'RESSARCIMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)) ? _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'top'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
    }],
    staticClass: "fa fa-question-circle text-gray",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Informe o número quando se tratar de documento fiscal ou um RPA com numeração<br/>Se for um documento sem numeração fiscal, como contra-cheque etc, pode deixar em branco</h5>'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.processo !== 'RESSARCIMENTO' ? 'required' : ''),
      expression: "processo !== 'RESSARCIMENTO' ? 'required' : ''"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "número da nota",
      "type": "text",
      "mask": _vm.processo !== 'RESSARCIMENTO' ? '#########' : '##########',
      "min": "1",
      "max": "2147483647",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    model: {
      value: (_vm.nota.numeroNota),
      callback: function($$v) {
        _vm.$set(_vm.nota, "numeroNota", $$v)
      },
      expression: "nota.numeroNota"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('número da nota')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número da nota')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('série')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Série:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.serieNota),
      expression: "nota.serieNota"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "série",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "serieNota", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NOTA_FISCAL"
    }
  }, [_vm._v("1 - Nota fiscal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RECIBO_PAGAMENTO_AUTONOMO"
    }
  }, [_vm._v("10 - Recibo de pagamento a autônomo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DOCUMENTO_NAO_FISCAL"
    }
  }, [_vm._v("DNF - Documento não fiscal")])])]), _vm._v(" "), (_vm.errors.first('série')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('série')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('data de emissão')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Data de emissão do documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "data de emissão",
      "input-class": "form-control datepicker",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "disabled-dates": {
        to: new Date(_vm.projeto.dateInicioSapiens),
        from: (new Date() < _vm.dataFinalConvenio) ? new Date() : _vm.dataFinalConvenio
      },
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.dataInclusao),
      callback: function($$v) {
        _vm.$set(_vm.nota, "dataInclusao", $$v)
      },
      expression: "nota.dataInclusao"
    }
  })], 1)]), _vm._v(" "), (_vm.errors.first('data de emissão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('data de emissão')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Data de validade do documento: (Somente informe se possuir a data)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "input-class": "form-control datepicker",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "disabled-dates": _vm.desabilitarDatasPassadas,
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.nota.dataValidade),
      callback: function($$v) {
        _vm.$set(_vm.nota, "dataValidade", $$v)
      },
      expression: "nota.dataValidade"
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || (_vm.processo === 'CONTRAPARTIDA' && _vm.ehNFe)) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field-field",
    class: {
      'has-error': _vm.errors.first('tipo de pessoa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.tipoFornecedor),
      expression: "nota.tipoFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo de pessoa",
      "disabled": _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "tipoFornecedor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.bloqueiaCamposFornecedorExistente = false, _vm.nota.nomeFornecedor = '', _vm.nota.cepFornecedor = '', _vm.nota.enderecoFornecedor = '', _vm.nota.cnpjFornecedor = '', _vm.nota.cpfFornecedor = '', _vm.nota.codigoFornecedor = ''
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Pessoa Física"
    }
  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pessoa Jurídica"
    }
  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.nota.tipoFornecedor === 'Pessoa Jurídica') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpj')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
    attrs: {
      "name": "cnpj",
      "mask": ['##.###.###/####-##'],
      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCpfCnpjSapiens(_vm.nota.cnpjFornecedor)
      }
    },
    model: {
      value: (_vm.nota.cnpjFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cnpjFornecedor", $$v)
      },
      expression: "nota.cnpjFornecedor"
    }
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.nota.codigoFornecedor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj vinculado a dirigente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj vinculado a dirigente')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.tipoFornecedor === 'Pessoa Física') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 65%; float: left' : ''),
    attrs: {
      "name": "cpf",
      "mask": ['###.###.###-##'],
      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.verificaCpfCnpjSapiens(_vm.nota.cpfFornecedor)
      }
    },
    model: {
      value: (_vm.nota.cpfFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cpfFornecedor", $$v)
      },
      expression: "nota.cpfFornecedor"
    }
  }), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "30%",
      "float": "left",
      "margin-left": "5%"
    },
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.nota.codigoFornecedor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.nomeFornecedor),
      expression: "nota.nomeFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text",
      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nota.nomeFornecedor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "nomeFornecedor", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('endereço')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.enderecoFornecedor),
      expression: "nota.enderecoFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "endereço",
      "type": "text",
      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    domProps: {
      "value": (_vm.nota.enderecoFornecedor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "enderecoFornecedor", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm._.has(_vm.nota, 'tipoFornecedor') && !_vm._.isNull(_vm.nota.tipoFornecedor)) ? _c('div', {
    staticClass: "form-group required-field row",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "mask": ['#####-###'],
      "disabled": _vm.bloqueiaCamposFornecedorExistente || _vm.ehNFe || _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.procurandoCidadeUF($event)
      }
    },
    model: {
      value: (_vm.nota.cepFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cepFornecedor", $$v)
      },
      expression: "nota.cepFornecedor"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), (_vm.nota.cepFornecedor) ? _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "padding": "7px"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? ' / ' + _vm.nota.estadoFornecedor : '') + "\n                        ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados Bancários " + _vm._s(_vm.processo === 'RESSARCIMENTO' ? ' de Beneficiário' : '') + " "), (_vm.loading.favorecido) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.processo === 'RESSARCIMENTO' && !_vm.loading.favorecido) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "mask": ['##.###.###/####-##'],
      "disabled": true,
      "type": "text"
    },
    model: {
      value: (_vm.nota.favorecido.codfav),
      callback: function($$v) {
        _vm.$set(_vm.nota.favorecido, "codfav", $$v)
      },
      expression: "nota.favorecido.codfav"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.favorecido.nomfav),
      expression: "nota.favorecido.nomfav"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.nota.favorecido.nomfav)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota.favorecido, "nomfav", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' || (_vm.usuarioLogado.userType !== 'FUNDACAO' && _vm.processo !== 'RESSARCIMENTO')) ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma de pagamento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Forma de pagamento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.forma_pagamento),
      expression: "nota.forma_pagamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "forma de pagamento",
      "disabled": _vm._.includes(['PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], _vm.processo) || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "forma_pagamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listaFormasPagamento), function(fp) {
    return _c('option', {
      domProps: {
        "value": fp.CodFpg
      }
    }, [_vm._v(_vm._s(fp.DesFpg))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('forma de pagamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma de pagamento')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {}, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('pagamento prioritário')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Pagamento Prioritário:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.pagamentoPrioritario),
      expression: "nota.pagamentoPrioritario"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "pagamento prioritário",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "pagamentoPrioritario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('pagamento prioritário')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('pagamento prioritário')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PAGAMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao && (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3')) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Contas Cadastradas Fornecedor:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    key: _vm.dadosBancariosFornecedores.length,
    attrs: {
      "options": _vm.dadosBancariosFornecedores,
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "allow-empty": false,
      "placeholder": "Selecione um dado bancário da lista ou inclua um novo",
      "name": "contas já cadastradas",
      "disabled": _vm.ehVisualizacao
    },
    on: {
      "select": _vm.selecionaDadosBancariosFornecedor
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Banco: " + _vm._s(props.option.banco))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Agência: " + _vm._s(props.option.agencia))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v("Conta: " + _vm._s(props.option.conta))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.ccbfav))]), _vm._v(" "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(('' + props.option.tipo) === '1' ? 'Conta Corrente' : ('' + props.option.tipo) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
      }
    }, {
      key: "noOptions",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v("Nenhum dado bancário encontrado.")])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_vm._v("\n                                    Banco: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.banco) + "  ")]), _vm._v("\n                                    Agência: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.agencia) + "  ")]), _vm._v("\n                                    Conta: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.conta))]), _vm._v("\n                                    Tipo: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(('' + props.option.tipo) === '1' ? 'Conta Corrente' : ('' + props.option.tipo) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
      }
    }], null, false, 1623321423),
    model: {
      value: (_vm.nota.favorecido.dadosBancariosSelecionados),
      callback: function($$v) {
        _vm.$set(_vm.nota.favorecido, "dadosBancariosSelecionados", $$v)
      },
      expression: "nota.favorecido.dadosBancariosSelecionados"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('contas já cadastradas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contas já cadastradas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PAGAMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao && (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3')) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _vm._m(13)]) : _vm._e()]), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required control-label col-md-4"
  }, [_vm._v("Tipo Documento:")]), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
    staticClass: "col-md-6 form-group required-field"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status",
      "checked": "true"
    },
    on: {
      "click": function($event) {
        return _vm.mudarTipoDocumento('boleto')
      }
    }
  }), _vm._v(" Boleto\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "status",
      "id": "status"
    },
    on: {
      "click": function($event) {
        return _vm.mudarTipoDocumento('imposto')
      }
    }
  }), _vm._v(" Imposto\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (('' + _vm.nota.forma_pagamento) === '4' && _vm._.includes(['PAGAMENTO', 'RESSARCIMENTO'], _vm.processo)) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [(this.tipoDocumento === 'boleto') ? _c('span', {
    staticStyle: {
      "color": "red",
      "margin-right": "2px"
    }
  }, [_vm._v("*")]) : _vm._e(), _vm._v("Código de Barras:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.boleto.numeroInformadoTela),
      expression: "nota.boleto.numeroInformadoTela"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "código de barras",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise', 'Análise Tributária', 'Autorização'], _vm.etapa)
    },
    domProps: {
      "value": (_vm.nota.boleto.numeroInformadoTela)
    },
    on: {
      "keyup": _vm.validaAjustaCodigoBarras,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota.boleto, "numeroInformadoTela", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('código de barras')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('código de barras')))]) : (_vm.nota.boleto.sucesso) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n                            " + _vm._s(_vm._.capitalize((_vm.nota.boleto.tipoCodigoInput + ' de ' + _vm.nota.boleto.tipoBoleto).replaceAll('_', ' ')) + ' correto!') + "\n                          ")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.nota.forma_pagamento === 3 || _vm.nota.forma_pagamento === '3' || _vm._.includes(['RESSARCIMENTO'], _vm.processo)) ? _c('div', {
    staticClass: "col-md-6"
  }, [(!_vm.loading.favorecido && !_vm.loading.tela) ? _c('div', [(_vm._.includes(['RESSARCIMENTO'], _vm.processo) && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostrarIncluindoConta && !_vm.ehVisualizacao),
      expression: "!mostrarIncluindoConta && !ehVisualizacao"
    }],
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('contas já cadastradas')
    },
    attrs: {
      "disabled": _vm.nota.favorecido.dadosBancariosSelecionados
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Contas já cadastradas:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.nota.formaPagamento !== 4
      }),
      expression: "{required: nota.formaPagamento !== 4}"
    }],
    key: _vm.opcoesContasExistentesFavorecido.length,
    attrs: {
      "options": _vm.opcoesContasExistentesFavorecido,
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "allow-empty": false,
      "placeholder": "Selecione um dado bancário da lista ou inclua um novo",
      "name": "contas já cadastradas",
      "disabled": _vm.ehVisualizacao
    },
    on: {
      "select": _vm.selecionaDadosBancariosFavorecido
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.codban))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.codage))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.ccbfav))]), _vm._v(" | "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(('' + props.option.tiptcc) === '1' ? 'Conta Corrente' : ('' + props.option.tiptcc) === '2' ? 'Conta Poupança' : 'Tipo de conta não definido'))])]
      }
    }, {
      key: "noOptions",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v("Nenhum dado bancário cadastrado. Favor Incluir banco, agência e conta")])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_vm._v("\n                                  Banco: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.codban) + "  ")]), _vm._v("\n                                  Agência: "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.codage) + "  ")]), _vm._v("\n                                  Conta " + _vm._s(('' + props.option.tiptcc) === '1' ? 'Corrente' : ('' + props.option.tiptcc) === '2' ? 'Poupança' : 'não definida') + ": "), _c('span', {
          staticClass: "text-blue"
        }, [_vm._v(_vm._s(props.option.ccbfav))])]
      }
    }], null, false, 465316643),
    model: {
      value: (_vm.nota.favorecido.dadosBancariosSelecionados),
      callback: function($$v) {
        _vm.$set(_vm.nota.favorecido, "dadosBancariosSelecionados", $$v)
      },
      expression: "nota.favorecido.dadosBancariosSelecionados"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('contas já cadastradas')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('contas já cadastradas')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'RESSARCIMENTO' && _vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa) && !_vm.mostrarIncluindoConta && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [(!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>Permite incluir na lista novo conjunto de dados bancários</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorecidoDadosBancariosIncluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")])], 1) : _vm._e(), _vm._v(" "), (_vm.opcoesContasExistentesFavorecido.length > 0 && !_vm._.isNull(_vm.nota.favorecido.dadosBancariosSelecionados)) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5>Exclui da lista os dados bancário selecionados</h5>'
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "error",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorecidoDadosBancariosExcluir($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Excluir")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS'], _vm.processo) || (_vm.processo === 'RESSARCIMENTO' && (!_vm._.isEmpty(_vm.nota.favorecido.dadosBancariosSelecionados) || _vm.mostrarIncluindoConta))),
      expression: "_.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS'], processo) || (processo === 'RESSARCIMENTO' && (!_.isEmpty(nota.favorecido.dadosBancariosSelecionados) || mostrarIncluindoConta))"
    }]
  }, [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('banco')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Banco:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.nota.formaPagamento !== 4
      }),
      expression: "{required: nota.formaPagamento !== 4}"
    }],
    attrs: {
      "options": _vm.listaBancos,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um banco",
      "custom-label": _vm.bancoNome,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "banco",
      "data-vv-as": "banco",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta)
    },
    on: {
      "select": _vm.selecionaBanco
    },
    model: {
      value: (_vm.bancoSelecionado),
      callback: function($$v) {
        _vm.bancoSelecionado = $$v
      },
      expression: "bancoSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('banco')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('banco')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('agência')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Agência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'bottom'}"
    }],
    attrs: {
      "title": '<h5> ' + (_vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? 'Informe a agência com 4 número sem dígito verificador. Exemplo: <span class=\'realce\'>1234</span>' : 'Informe a agência com 4 número e o dígito verificador. Exemplo: <span class=\'realce\'>1234-5</span>') + ' </h5>'
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "agência",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta),
      "type": "text",
      "mask": _vm._.has(_vm.bancoSelecionado, 'digitoAgencia') && !_vm.bancoSelecionado.digitoAgencia ? '####' : '####-X',
      "tokens": _vm.agenciaTokens,
      "masked": ""
    },
    model: {
      value: (_vm.nota.dados_bancarios.agencia),
      callback: function($$v) {
        _vm.$set(_vm.nota.dados_bancarios, "agencia", $$v)
      },
      expression: "nota.dados_bancarios.agencia"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('agência')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('agência')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('conta corrente')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Conta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:3'),
      expression: "'required|min:3'"
    }],
    staticClass: "form-control text-right",
    attrs: {
      "name": "conta corrente",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta),
      "type": "text",
      "mask": ['#-X', '##-X', '###-X', '####-X', '#####-X', '######-X', '#######-X', '########-X', '#########-X', '##########-X', '###########-X'],
      "tokens": _vm.customTokens,
      "masked": ""
    },
    model: {
      value: (_vm.nota.dados_bancarios.conta),
      callback: function($$v) {
        _vm.$set(_vm.nota.dados_bancarios, "conta", $$v)
      },
      expression: "nota.dados_bancarios.conta"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('conta corrente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('conta corrente')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo da conta')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("Tipo da Conta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.nota.formaPagamento !== 4
      }),
      expression: "{required: nota.formaPagamento !== 4}"
    }],
    attrs: {
      "options": _vm.tiposConta,
      "multiple": false,
      "close-on-select": true,
      "preselect-first": true,
      "allow-empty": false,
      "custom-label": _vm.tipoContaNome,
      "placeholder": "Selecione um tipo de conta",
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "",
      "deselectLabel": "",
      "name": "tipo da conta",
      "data-vv-as": "tipo da conta",
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.processo === 'PRESTACAO_DE_CONTAS' || (_vm.processo === 'RESSARCIMENTO' && !_vm.mostrarIncluindoConta)
    },
    on: {
      "select": _vm.selecionaTipoConta
    },
    model: {
      value: (_vm.tipoContaSelecionado),
      callback: function($$v) {
        _vm.tipoContaSelecionado = $$v
      },
      expression: "tipoContaSelecionado"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('tipo da conta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo da conta')))]) : _vm._e()])])]), _vm._v(" "), _vm._m(14), _vm._v(" "), (_vm.mostrarIncluindoConta) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorecidoDadosBancariosOk($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favorecidoDadosBancariosCancelar($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar")])], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "box-body",
    attrs: {
      "id": "adiantamentosConcedidos"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Adiantamentos Concedidos "), (_vm.loading.adiantamentos) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.adiantamentos) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "control-label col-md-4",
    attrs: {
      "title": '<h5>Filtros não alteram o total</h5>'
    }
  }, [_vm._v("Mostrar adiantamentos: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "checkbox-inline",
    attrs: {
      "title": '<h5>Mostrar o(s) adiantmentos com prestações pendentes</h5>'
    }
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adiantamentosFiltrosSelecionados),
      expression: "adiantamentosFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "adiantamento_pendente"
    },
    domProps: {
      "checked": Array.isArray(_vm.adiantamentosFiltrosSelecionados) ? _vm._i(_vm.adiantamentosFiltrosSelecionados, "adiantamento_pendente") > -1 : (_vm.adiantamentosFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.adiantamentosFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "adiantamento_pendente",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.adiantamentosFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.adiantamentosFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.adiantamentosFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Pendente de prestação de contas "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive parcelasAdiantamento"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', [_c('tr', [_c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Número da parcela (ordem) do adiantamento</h5>'
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Valor da parcela no instrumento legal</h5>'
    }
  }, [_vm._v("Valor previsto")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Valor solicitado dentro do limite total da parcela</h5>'
    }
  }, [_vm._v("Valor adiantado")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Total das prestações de contas realizadas para o valor adiantado</h5>'
    }
  }, [_vm._v("Valor Pendente")]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado borda",
    attrs: {
      "title": '<h5>Percentual das prestações de contas realizadas para o valor adiantado</h5>'
    }
  }, [_vm._v("% Comprov.")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.adiantamentosConcecidos), function(adiantamento) {
    return [(!_vm._.has(adiantamento, 'mostrar') || adiantamento.mostrar) ? [_c('tr', [_c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(adiantamento.parcela))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.contratado)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.requisitado)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(adiantamento.pendente_comprovacao)))]), _vm._v(" "), _c('td', {
      class: 'celula centralizado borda ' + (adiantamento.percentual_comprovado >= 1 ? 'atingido100' : (adiantamento.percentual_comprovado >= 0.8 ? 'atingido80' : 'nao_atingido'))
    }, [_vm._v(_vm._s(_vm._f("percentage")(adiantamento.percentual_comprovado)))])])] : _vm._e()]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm._.keys(_vm._.groupBy(_vm.adiantamentosConcecidos, 'recurso')).length === 2) ? _c('table', {
    staticClass: "totais"
  }, [_vm._m(15), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto em parcela(s) com recursos da Fundação BB</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado com recursos da Fundação BB</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.saldo)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto em parcela(s) com recursos de Parceiros Estratégicos</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado com recursos de Parceiros Estratégicos</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.saldo)) + "\n                            ")])])])]) : _c('table', {
    staticClass: "totais"
  }, [_vm._m(16), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total já solicitado de adiantamento para esta projeto</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.solicitado)) + "\n                            ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Valor total pendente de prestação de contas de acordo com total de adiantamento solicitado</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.saldo)) + "\n                            ")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.processo !== 'CONTRAPARTIDA' && _vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "calculoImposto"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cálculo de Impostos "), (_vm.loading.analise_tributaria) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12 form-group required-field"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tributado?")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.tributacao),
      expression: "nota.tributacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "tributacao",
      "disabled": _vm.ehVisualizacao || (_vm._.includes(['TRIBUTADO', 'NAO_TRIBUTADO'], _vm.nota.tributacao) && !_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) || _vm.processo === 'RESSARCIMENTO'
    },
    domProps: {
      "value": 'TRIBUTADO',
      "checked": _vm._q(_vm.nota.tributacao, 'TRIBUTADO')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.nota, "tributacao", 'TRIBUTADO')
      }
    }
  }), _vm._v(" Sim\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.tributacao),
      expression: "nota.tributacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "tributacao",
      "disabled": _vm.ehVisualizacao || (_vm._.includes(['TRIBUTADO', 'NAO_TRIBUTADO'], _vm.nota.tributacao) && !_vm._.includes(['Análise', 'Análise Tributária'], _vm.etapa)) || _vm.processo === 'RESSARCIMENTO'
    },
    domProps: {
      "value": 'NAO_TRIBUTADO',
      "checked": _vm._q(_vm.nota.tributacao, 'NAO_TRIBUTADO')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.nota, "tributacao", 'NAO_TRIBUTADO')
      }
    }
  }), _vm._v(" Não\n                          "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('tributacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tributacao')))]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.analise_tributaria && !_vm._.isEmpty(_vm.analiseTributaria) && _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(17), _vm._v(" "), _c('tbody', [_vm._l((_vm.analiseTributaria.produtos), function(produto) {
    return _c('tr', [_c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "celula centralizado borda",
      attrs: {
        "title": '<h5>' + produto.CplPro + '</h5>'
      }
    }, [_vm._v(_vm._s(produto.CodPro) + " / " + _vm._s(produto.DesPro))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(0))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(0 / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrCrt))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerCof / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrPit))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerPit / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrCsl))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerCsl / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrIrf))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerIrf / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(0))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(0 / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(produto.VlrOur))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(produto.PerOur / 100)))])])
  }), _vm._v(" "), _vm._l((_vm.analiseTributaria.servicos), function(servico) {
    return _c('tr', [_c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          placement: 'top',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', placement:'top', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "celula centralizado borda",
      staticStyle: {
        "width": "25%",
        "font-weight": "bold"
      },
      attrs: {
        "title": '<h5>' + servico.CplSer + '</h5>'
      }
    }, [_vm._v("\n                              " + _vm._s(servico.CodSer) + " / " + _vm._s(servico.DesSer) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIss))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIss / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrCrt))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerCof / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrPit))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerPit / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrCsl))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerCsl / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIrf))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIrf / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrIns))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerIns / 100)))]), _vm._v(" "), _c('td', {
      staticClass: "celula centralizado borda"
    }, [_vm._v(_vm._s(_vm._f("real")(servico.VlrOur))), _c('br'), _vm._v(_vm._s(_vm._f("percentage")(servico.PerOur / 100)))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total desta Solicitação")]), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total de Tributação")]) : _vm._e(), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total Líquido")]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.analiseTributaria.nf.VlrInf)))]), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
    staticClass: "centralizado valor"
  }, [_c('money', {
    staticClass: "form-control text-center",
    staticStyle: {
      "width": "60%",
      "margin-left": "20%"
    },
    attrs: {
      "name": "Total valorTributado",
      "type": "text",
      "disabled": !_vm._.includes(['Análise Tributária'], _vm.etapa)
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.nota.valorTributado = _vm.limitaFaixaEntrada('decimal', _vm.nota.valorTributado, 0, _vm.analiseTributaria.nf.VlrInf)
      }
    },
    model: {
      value: (_vm.nota.valorTributado),
      callback: function($$v) {
        _vm.$set(_vm.nota, "valorTributado", $$v)
      },
      expression: "nota.valorTributado"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.nota.tributacao === 'TRIBUTADO') ? _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(_vm._s(_vm._f("real")((parseFloat(_vm.analiseTributaria.nf.VlrInf) - _vm.nota.valorTributado))))]) : _vm._e()])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "cronogramaPagamento"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cronograma "), (_vm.loading.cronograma) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm.loading.cronograma) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "control-label col-md-2",
    attrs: {
      "title": '<h5>Filtros não alteram o total</h5>'
    }
  }, [_vm._v("Mostrar item: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "checkbox-inline",
    attrs: {
      "title": '<h5>Mostrar o(s) item(ns) que ainda contém saldo</h5>'
    }
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extratoFiltrosSelecionados),
      expression: "extratoFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "saldos",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.extratoFiltrosSelecionados) ? _vm._i(_vm.extratoFiltrosSelecionados, "saldos") > -1 : (_vm.extratoFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.extratoFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "saldos",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.extratoFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.extratoFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.extratoFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Com saldo "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm._.has(_vm.validacao, 'itens_liberados')) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "checkbox-inline",
    attrs: {
      "title": '<h5>Mostrar somente o(s) item(ns) que foram solicitados</h5>'
    }
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extratoFiltrosSelecionados),
      expression: "extratoFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitados",
      "disabled": _vm.ehVisualizacao || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
    },
    domProps: {
      "checked": Array.isArray(_vm.extratoFiltrosSelecionados) ? _vm._i(_vm.extratoFiltrosSelecionados, "solicitados") > -1 : (_vm.extratoFiltrosSelecionados)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.extratoFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitados",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.extratoFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.extratoFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.extratoFiltrosSelecionados = $$c
        }
      }, function($event) {
        _vm.filtrarExtrato();
        _vm.calcularTotaisExtato()
      }]
    }
  }), _vm._v(" Somente solicitado "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (_vm.totais.projeto.fbb.orcado > 0 && _vm.totais.projeto.parceiros.orcado > 0) ? _c('span', [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    },
    attrs: {
      "title": '<h5>' + (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.fbb.saldo <= 0 ? 'Não há pendência de prestação de contas com recursos da Fundação BB' : 'Mostrar o(s) item(ns) relacionados a Fundação BB') + '</h5>'
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "filtro_origem_recurso",
      "disabled": _vm.ehVisualizacao || (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.fbb.saldo <= 0) || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
    },
    domProps: {
      "checked": _vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao')
    },
    on: {
      "click": function($event) {
        return _vm.filtrarPorOrigemRecurso('fundacao')
      }
    }
  }), _vm._v(" Fundação "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "radio-inline new-control new-control-radio",
    staticStyle: {
      "padding-top": "7px"
    },
    attrs: {
      "title": '<h5>' + (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.parceiros.saldo <= 0 ? 'Não há pendência de prestação de contas com recursos de Parceiro Estratégico' : 'Mostrar o(s) item(ns) relacionados ao Parceiro Estratégico') + '</h5>'
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "filtro_origem_recurso",
      "disabled": _vm.ehVisualizacao || (_vm.processo === 'PRESTACAO_DE_CONTAS' && _vm.totais.adiantamento.parceiros.saldo <= 0) || !_vm._.includes(['Solicitação', 'Revisão', 'Análise'], _vm.etapa)
    },
    domProps: {
      "checked": _vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro')
    },
    on: {
      "click": function($event) {
        return _vm.filtrarPorOrigemRecurso('parceiro')
      }
    }
  }), _vm._v(" Parceiro Estratégico "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e()])])]), _vm._v(" "), (_vm.totais.projeto.fbb.orcado > 0 && _vm.totais.projeto.parceiros.orcado > 0) ? _c('div', {
    staticClass: "col-md-offset-2 col-md-10",
    staticStyle: {
      "color": "var(--cor-destaque)",
      "margin-top": "-10px"
    }
  }, [_vm._v("\n                        Atenção: Selecione os itens relacionados a Fundação "), _c('strong', [_vm._v("OU")]), _vm._v(" ao Parceiro Estratégico\n                      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "2",
      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "2",
      "title": '<h5>Informe o que consta no documento (quantidade e valor)</h5>'
    }
  }, [_vm._v(_vm._s(_vm.processo === 'CONTRAPARTIDA' ? 'Comprovação' : 'Solicitação'))]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "2",
      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
    }
  }, [_vm._v("Saldo")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('th') : _vm._e()]), _vm._v(" "), _c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', [_vm._v(_vm._s((_vm.layoutExtrato === 'porOrigem' ? 'Origem do Recurso' : 'Atividade')) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Economicidade")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l(((_vm.layoutExtrato === 'classico' ? [
    ['1', '5', '2']
  ] : (_vm.layoutExtrato === 'porOrigem') ? [
    ['1', '5']
  ] : [
    ['2']
  ])), function(origem) {
    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
      staticClass: "atividade",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s((_vm._.includes(origem, '2')) ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.cronograma.atividades), function(atividade) {
      return ((_vm._.filter(_vm.cronograma.itens, function(i) {
        return i.Atividade_nome === atividade.Nome && _vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + i.Item_Origem).substring(0, 1)) && (!_vm._.has(i, 'mostrar') || i.mostrar)
      })).length > 0) ? [(_vm.layoutExtrato === 'classico') ? _c('tr', {
        staticClass: "atividade"
      }, [_c('td', {
        staticClass: "esquerda celula b1 b3 b4 nome_atividade"
      }, [_vm._v(_vm._s(atividade.Nome))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [_vm._v(" ")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [_vm._v(" ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.filter(_vm.cronograma.itens, {
        'Atividade_nome': atividade.Nome
      })), function(item) {
        return (_vm._.includes((_vm.processo === 'CONTRAPARTIDA' ? ['2'] : ['1', '5']), ('' + item.Item_Origem).substring(0, 1))) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', [_c('td', {
          staticClass: "celula b3 b4"
        }, [_c('div', {
          staticClass: "item",
          style: (_vm.usuarioLogado.userType === 'FUNDACAO' ? 'width: 80%; float: left;' : '')
        }, [_c('div', {
          staticClass: "item_despesa esquerda"
        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.Item_Tipo))) + ")  " + _vm._s(item.Item + ' / ' + item.Item_Descricao))]), _vm._v(" "), _c('div', {
          staticClass: "observacao esquerda",
          domProps: {
            "innerHTML": _vm._s('<span class=id_item>#' + item.Id_item + '</span>  ' + item.Item_Observacao + '</span>')
          }
        })]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
          staticStyle: {
            "width": "20%",
            "text-align": "right",
            "float": "right",
            "color": "var(--cor-fraca)"
          }
        }, [_vm._v(_vm._s(item.Item_Conta))]) : _vm._e()]), _vm._v(" "), _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado celula b3 b4",
          attrs: {
            "title": '<h5>' + (!_vm._.has(item, 'Item_Unidade_medida') || _vm._.isNull(item.Item_Unidade_medida) ? 'Sem unid. de medida' : (item.Item_Unidade_medida === 'Outros' && _vm._.has(item, 'Item_Unidade_medida_outros') && !_vm._.isNull(item.Item_Unidade_medida_outros) ? ('Outros:<br/>' + item.Item_Unidade_medida_outros) : item.Item_Unidade_medida)) + '</h5>'
          }
        }, [_vm._v("\n                                      " + _vm._s(item.Qtde_orcado) + "\n                                    ")]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3"
        }, [_vm._v("\n                                      " + _vm._s(_vm._f("decimal2")(item.Valor_orcado)) + "\n                                    ")]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b4 qtdeSolicitacao",
          class: parseFloat(item.Qtde_solicitado) === 0 && parseFloat(item.Valor_solicitado) !== 0 ? 'qtde_pendente' : ''
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.Qtde_solicitado),
            expression: "item.Qtde_solicitado"
          }],
          staticClass: "form-control text-right qtdeSolicitacao",
          attrs: {
            "name": "quantidade a solicitar",
            "type": "text",
            "disabled": parseFloat(item.Qtde_saldo) <= 0 || parseFloat(item.Valor_saldo) <= 0 || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
          },
          domProps: {
            "value": (item.Qtde_solicitado)
          },
          on: {
            "keyup": function($event) {
              item.Qtde_solicitado = _vm.limitaFaixaEntrada('inteiro', item.Qtde_solicitado, 0, item.Qtde_saldo)
            },
            "blur": _vm.verificaCorrigeDados,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(item, "Qtde_solicitado", $event.target.value)
            }
          }
        })]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 valorSolicitacao",
          class: parseFloat(item.Qtde_solicitado) !== 0 && parseFloat(item.Valor_solicitado) === 0 ? 'valor_pendente' : ''
        }, [_c('money', {
          staticClass: "form-control text-right valorSolicitacao",
          attrs: {
            "name": "valor a solicitar",
            "type": "text",
            "disabled": parseFloat(item.Qtde_saldo) <= 0 || parseFloat(item.Valor_saldo) <= 0 || _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)
          },
          nativeOn: {
            "keyup": function($event) {
              item.Valor_solicitado = _vm.limitaFaixaEntrada('decimal', item.Valor_solicitado, 0, item.Valor_saldo)
            },
            "blur": function($event) {
              return _vm.calcularTotaisExtato($event)
            }
          },
          model: {
            value: (item.Valor_solicitado),
            callback: function($$v) {
              _vm.$set(item, "Valor_solicitado", $$v)
            },
            expression: "item.Valor_solicitado"
          }
        })], 1), _vm._v(" "), _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado celula b3 b4",
          attrs: {
            "title": '<h5>' + (!_vm._.has(item, 'Item_Unidade_medida') || _vm._.isNull(item.Item_Unidade_medida) ? 'Sem unid. de medida' : (item.Item_Unidade_medida === 'Outros' && _vm._.has(item, 'Item_Unidade_medida_outros') && !_vm._.isNull(item.Item_Unidade_medida_outros) ? ('Outros:<br/>' + item.Item_Unidade_medida_outros) : item.Item_Unidade_medida)) + '</h5>'
          }
        }, [_vm._v("\n                                      " + _vm._s(item.Qtde_saldo - parseFloat(item.Qtde_solicitado)) + "\n                                    ")]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b2 b3"
        }, [_vm._v("\n                                      " + _vm._s(_vm._f("decimal2")(item.Valor_saldo - parseFloat(item.Valor_solicitado))) + "\n                                    ")]), _vm._v(" "), (_vm.processo === 'CONTRAPARTIDA' && _vm._.includes(['Análise'], _vm.etapa)) ? _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "centralizado celula b2 b3 b4",
          attrs: {
            "title": '<h5>Seleciona aqui se o item está comprovado com economicidade</h5>'
          }
        }, [_c('label', {
          staticClass: "checkbox-inline new-control new-control-checkbox",
          staticStyle: {
            "vertical-align": "top"
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.Economicidade),
            expression: "item.Economicidade"
          }],
          attrs: {
            "type": "checkbox",
            "false-value": 0,
            "true-value": 1,
            "disabled": parseFloat(item.Qtde_solicitado) === 0 && parseFloat(item.Valor_solicitado) === 0 || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao
          },
          domProps: {
            "checked": Array.isArray(item.Economicidade) ? _vm._i(item.Economicidade, null) > -1 : _vm._q(item.Economicidade, 1)
          },
          on: {
            "change": [function($event) {
              var $$a = item.Economicidade,
                $$el = $event.target,
                $$c = $$el.checked ? (1) : (0);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(item, "Economicidade", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(item, "Economicidade", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(item, "Economicidade", $$c)
              }
            }, _vm.selecaoEconomicidade]
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "new-control-indicator"
        })])]) : _vm._e()])] : _vm._e()] : _vm._e()
      })] : _vm._e()
    })]
  })], 2)])])]), _vm._v(" "), (!_vm.loading.cronograma) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.adiantamento.total.orcado !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Limite pendente")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total desta Solicitação")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos da Fundação</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos de Parceiro Estratégico</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos da Contrapartida</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado para este projeto</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.orcado)) + "\n                              ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantamento.total.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado para Adiantamento</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.orcado)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), (_vm.processo === 'PRESTACAO_DE_CONTAS') ? _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Saldo máximo disponível sobre o(s) adiantamento(s) liberados(s) com recursos da <span class=\'realce\'>Fundação</span> para prestar contas ou devolver</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.adiantamento.fbb.saldo)))]) : (_vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro')) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    attrs: {
      "title": '<h5>Saldo máximo disponível sobre o(s) adiantamento(s) liberados(s) com recursos de <span class=\'realce\'>Parceiro Estratégicos</span> para prestar contas ou devolver</h5>'
    }
  }, [_vm._v(_vm._s(_vm._f("real")(_vm.totais.adiantamento.parceiros.saldo)))]) : _c('span', {
    staticClass: "realce"
  }, [_vm._v("Deve selecionar Fundação ou Parceiro no filtro")])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor",
    attrs: {
      "rowspan": "2"
    }
  }, [(_vm.processo === 'PRESTACAO_DE_CONTAS' && (
    (_vm._.includes(_vm.extratoFiltrosSelecionados, 'fundacao') && _vm.totais.projeto.fbb.solicitado > _vm.totais.adiantamento.fbb.saldo) ||
    (_vm._.includes(_vm.extratoFiltrosSelecionados, 'parceiro') && _vm.totais.projeto.parceiros.solicitado > _vm.totais.adiantamento.parceiros.saldo))) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "label label-danger",
    staticStyle: {
      "font-style": "unset"
    },
    attrs: {
      "title": '<h5>O total desta solicitação ultrapassou o limite pendente (saldo máximo disponível) para prestar contas</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.solicitado)) + "\n                              ")]) : _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total desta solicitação</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.solicitado)) + "\n                              ")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos da Fundação com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.fbb.saldo / _vm.totais.projeto.fbb.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos de Parceiro Estratégico com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.parceiros.saldo / _vm.totais.projeto.parceiros.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos da Contrapartida com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.contrapartida.saldo / _vm.totais.projeto.contrapartida.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo total do projeto com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.total.saldo / _vm.totais.projeto.total.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.saldo)) + "\n                              ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantamento.total.orcado !== 0 && false) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos Adiantamento não solicitados ainda</h5>'
    }
  }, [_vm._v("\n                                " + _vm._s(_vm._f("real")(_vm.totais.adiantamento.total.saldo)) + "\n                              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_vm._v(" ")])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.ehNFe && !_vm._.isNull(_vm.nfe.xmlNfe) && !_vm._.isNull(_vm.nfe.protocoloValidacao)) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(19), _vm._v(" "), _c('tbody', _vm._l((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item['@nItem']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.prod.xProd) + " "), (_vm._.has(item.prod, 'DI')) ? _c('span', {
      staticStyle: {
        "color": "var(--cor-atencao)",
        "font-weight": "bold"
      }
    }, [_vm._v(" (importado)")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("decimal2")(item.prod.qCom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.prod.vUnCom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("real")(item.prod.vProd)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "totais"
  }, [_vm._m(20), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Quantidade de itens que consta nesta NF-e</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det).length) + "\n                          ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total bruto desta NF-e</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.sumBy((_vm._.isPlainObject(_vm.nfe.xmlNfe.NFe.infNFe.det) ? [_vm.nfe.xmlNfe.NFe.infNFe.det] : _vm.nfe.xmlNfe.NFe.infNFe.det), function(i) {
    return (i.prod.indTot === '1' ? parseFloat(i.prod.vProd) : 0)
  }))) + "\n                          ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.ehProjetoEspecial && _vm.usuarioLogado.userType === 'FUNDACAO' && _vm.processo === 'PAGAMENTO' && _vm.aprovacao.resultadoAprovacao !== 'Revisão') ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.mostrarDadosComplementares = !_vm.mostrarDadosComplementares
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrarDadosComplementares ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Dados complementares")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        placement: 'top'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
    }],
    staticClass: "fa fa-question-circle text-gray",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Projetos Especiais (Enchentes, Covid, BPB etc) nescessitam de dados complementares como qual o município, valor e quantidade de participantes os quais são destinados este pagamento</h5>'
    }
  }), _vm._v(" "), (_vm.loading.municipios) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])])]), _vm._v(" "), (_vm.mostrarDadosComplementares) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.etapa === 'Análise') ? _c('span', [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss",
      "href": "javascript:void(0)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.novoDadosComplementares($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir\n                      ")]), _vm._v(" "), _c('br'), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "centralizado w20"
  }, [_vm._v("Município")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado w15"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado w30"
  }, [_vm._v("Destinação")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado w10"
  }, [_vm._v("Famílias")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado w10"
  }, [_vm._v("Participantes")]), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('th', {
    staticClass: "centralizado w10"
  }, [_vm._v("Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nota.dadosComplementares), function(item, index) {
    return (_vm.nota.dadosComplementares.length > 0) ? _c('tr', {
      key: index + item.municipio
    }, [_c('td', {
      staticClass: "centralizado"
    }, [_c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true,
          placement: 'top'
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
      }],
      attrs: {
        "title": '<h5>' + (_vm._.has(item.municipio, 'nomcid') ? item.municipio.nomcid + ' / ' + item.municipio.sigufs : 'Selecione um município') + '</h5>'
      }
    }, [_c('multiselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "options": _vm.municipiosUf,
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
        "placeholder": "Nome do município",
        "label": "nomcid",
        "group-values": "municipios",
        "group-label": "uf",
        "track-by": "codrai",
        "preselect-first": false,
        "close-on-select": true,
        "selectLabel": "Selecionar",
        "deselectLabel": "Desselecionar",
        "selectedLabel": "",
        "name": "municipio"
      },
      model: {
        value: (item.municipio),
        callback: function($$v) {
          _vm.$set(item, "municipio", $$v)
        },
        expression: "item.municipio"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [_c('money', {
      staticClass: "form-control text-center",
      attrs: {
        "name": "valor em dado complementar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      nativeOn: {
        "keyup": function($event) {
          item.valor = _vm.limitaFaixaEntrada('decimal', item.valor, 0, _vm.totais.projeto.total.solicitado)
        }
      },
      model: {
        value: (item.valor),
        callback: function($$v) {
          _vm.$set(item, "valor", $$v)
        },
        expression: "item.valor"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.destinacao),
        expression: "item.destinacao"
      }],
      staticClass: "form-control",
      attrs: {
        "name": "destinacao em dado complementar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      domProps: {
        "value": (item.destinacao)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "destinacao", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.familias),
        expression: "item.familias"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "name": "familias em dado complementar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      domProps: {
        "value": (item.familias)
      },
      on: {
        "keyup": function($event) {
          item.familias = _vm.limitaFaixaEntrada('inteiro', item.familias, 0, 9999999)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "familias", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "centralizado"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.participantes),
        expression: "item.participantes"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "name": "participantes em dado complementar",
        "type": "text",
        "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
      },
      domProps: {
        "value": (item.participantes)
      },
      on: {
        "keyup": function($event) {
          item.participantes = _vm.limitaFaixaEntrada('inteiro', item.participantes, 0, 9999999)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "participantes", $event.target.value)
        }
      }
    })]), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('td', {
      staticClass: "centralizado"
    }, [_c('g-button-moema', {
      attrs: {
        "color": "error",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.excluiDadosComplementares(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1) : _vm._e()]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.mostrarDadosComplementares) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.nota.dadosComplementares.length > 0) ? _c('table', {
    staticClass: "totais"
  }, [_vm._m(21), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Se trata da quantidade registros de dados complementares que há acima</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.nota.dadosComplementares.length) + "\n                          ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total discriminado nos registros destes dados complementares<br/><br/>Não pode exceder o limite do solicitado nesta ID de<br/>R$ ' + (_vm.totais.projeto.total.solicitado) + '</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("real")(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
    return parseFloat(d.valor)
  }))) + "\n                            "), (_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
    return parseFloat(d.valor)
  }) > _vm.totais.projeto.total.solicitado) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Ultrapassou " + _vm._s(_vm._f("real")((_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
    return parseFloat(d.valor)
  }) - _vm.totais.projeto.total.solicitado))))]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Quantidde total de famílias beneficiadas informadas nestes dados complementares</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
    return parseInt(d.familias)
  })) + "\n                          ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Quantidde total de participantes beneficiários informados nestes dados complementares</h5>'
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._.sumBy(_vm.nota.dadosComplementares, function(d) {
    return parseInt(d.participantes)
  })) + "\n                          ")])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "infoProjetoObservacoes"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Informações do Projeto "), (_vm.loading.analise_tributaria) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.analiseTributaria)) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_vm._m(22), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "celula centralizado borda"
  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codban))]), _vm._v(" "), _c('td', {
    staticClass: "celula centralizado borda"
  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codage))]), _vm._v(" "), _c('td', {
    staticClass: "celula centralizado borda"
  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.ccbfor))]), _vm._v(" "), _c('td', {
    staticClass: "celula centralizado borda"
  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.usu_mci))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "celula centralizado borda",
    attrs: {
      "title": '<h5>' + _vm.analiseTributaria.contas_projeto.DesCco + '</h5>'
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.analiseTributaria.contas_projeto.NumCco) + "\n                            ")]), _vm._v(" "), _c('td', {
    staticClass: "celula centralizado borda"
  }, [_vm._v(_vm._s(_vm.analiseTributaria.projeto.codtpj))])])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "observacaoCI"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Observação do Documento Fiscal "), (_vm.loading.analise_tributaria) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (!_vm._.isEmpty(_vm.analiseTributaria)) ? _c('div', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_nf",
      "rows": "3",
      "disabled": true
    },
    model: {
      value: (_vm.analiseTributaria.nf.ObsNfc),
      callback: function($$v) {
        _vm.$set(_vm.analiseTributaria.nf, "ObsNfc", $$v)
      },
      expression: "analiseTributaria.nf.ObsNfc"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php', {
    attrs: {
      "propDocumentos": _vm.nota.anexos,
      "documentTypes": '',
      "disable": _vm.ehVisualizacao || _vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa),
      "local-uso": 'SOLICITACAO_PAGAMENTO'
    }
  })], 1)]), _vm._v(" "), (_vm._.includes(['Revisão', 'Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) || _vm.ehVisualizacao) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico de solicitação "), (_vm.loading.cronograma) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando...")]) : _vm._e()])]), _vm._v(" "), (_vm.historicoBack && !_vm._.isNull(_vm.historicoBack) && !_vm._.isEmpty(_vm.historicoBack)) ? _c('historico-solicitacao-pagamento', {
    key: _vm.historicoBack,
    attrs: {
      "propsValidacao": _vm.validacao,
      "propsHistorico": _vm.historicoBack
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack)) && !_vm.loading.cronograma) ? _c('div', {
    staticClass: "text-left box-header"
  }, [(_vm.esconderHistorico === false) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar histórico antigo")]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.esconderHistorico = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ocultar histórico antigo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.esconderHistorico === true && _vm.dataMenor === true || (!_vm.historicoBack || _vm._.isNull(_vm.historicoBack) || _vm._.isEmpty(_vm.historicoBack)) && !_vm.loading.cronograma) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_vm._m(24), _vm._v(" "), _c('historico-antigo', {
    key: _vm.historicoTarefas,
    attrs: {
      "propsValidacao": _vm.validacao,
      "propsHistorico": _vm.historicoTarefas
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && _vm.usuarioLogado.userType !== 'FUNDACAO')) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._m(25), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.observacao),
      expression: "nota.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_opcional",
      "id": "observacao_opcional",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nota.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "observacao", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.entidade) && !_vm.loading.tela && _vm.processo !== 'CONTRAPARTIDA') ? _c('div', {
    staticClass: "box-body ciente_declaracoes"
  }, [(_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', _vm._l((_vm.declaracoes), function(declaracao) {
    return _c('div', {
      class: 'alert alert-dismissible alert-' + (_vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'success' : 'warning')
    }, [_vm._m(26, true), _vm._v(" "), _c('p', [_c('i', {
      class: _vm._.find(_vm.cienteDeclaracoes, ['codigo', declaracao.codigo]) ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.ciente(declaracao.codigo)
        }
      }
    }), _vm._v("\n                        " + _vm._s(_vm.textoDeclaracao(declaracao.texto)) + "\n                      ")])])
  }), 0) : _c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.cienteDeclaracoes), function(declaracao) {
    return _c('div', {
      staticClass: "form-group well"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_vm._v(_vm._s(_vm.textoDeclaracao(declaracao.texto)))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 text-right"
    }, [_vm._v("\n                        " + _vm._s(declaracao.usuario.nome)), _c('br'), _vm._v("\n                        " + _vm._s(_vm._f("moment")(declaracao.data, 'DD/MM/YYYY HH:mm')) + "\n                      ")])])
  }), 0)]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "decisoes_aprovação"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))),
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.aprovacao, "resultadoAprovacao", _vm.etapa === 'Análise' ? (_vm.processo === 'CONTRAPARTIDA' ? 'Conclusão' : 'Análise Tributária') : (_vm.etapa === 'Análise Tributária' ? 'Autorização' : (_vm.etapa === 'Autorização' ? (_vm.processo === 'PRESTACAO_DE_CONTAS' ? 'Conclusão' : (_vm.ativaGeracaoRemessa ? 'Liquidação' : 'Conclusão')) : (_vm.etapa === 'Liquidação' ? 'Conclusão' : ''))))
      }
    }
  }), _vm._v(" " + _vm._s(_vm.etapa === 'Liquidação' ? 'Concluir processo manualmente' : 'Aprovar solicitação') + "\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm.processo !== 'CONTRAPARTIDA' && ((_vm.etapa === 'Análise' && _vm.aprovacao.resultadoAprovacao === 'Análise Tributária') || (_vm.etapa === 'Análise Tributária' && _vm.aprovacao.resultadoAprovacao === 'Autorização') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Conclusão') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Liquidação'))) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Integrar com Sapiens?")]), _vm._v(" "), _c('span', [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.bypass),
      expression: "nota.bypass"
    }],
    attrs: {
      "type": "radio",
      "name": "bypass",
      "disabled": _vm.etapa !== 'Análise' || _vm.ehVisualizacao
    },
    domProps: {
      "value": '',
      "checked": _vm._q(_vm.nota.bypass, '')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.nota, "bypass", '')
      }
    }
  }), _vm._v(" Sim\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.bypass),
      expression: "nota.bypass"
    }],
    attrs: {
      "type": "radio",
      "name": "bypass",
      "disabled": _vm.etapa !== 'Análise' || _vm.ehVisualizacao
    },
    domProps: {
      "value": 'BYPASS',
      "checked": _vm._q(_vm.nota.bypass, 'BYPASS')
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.nota, "bypass", 'BYPASS')
      }
    }
  }), _vm._v(" Não\n                                "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [((_vm.etapa === 'Análise' && _vm.aprovacao.resultadoAprovacao === 'Análise Tributária') || (_vm.etapa === 'Análise Tributária' && _vm.aprovacao.resultadoAprovacao === 'Autorização') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Conclusão') || (_vm.etapa === 'Autorização' && _vm.aprovacao.resultadoAprovacao === 'Liquidação') || (_vm.etapa === 'Análise' && _vm.aprovacao.resultadoAprovacao === 'Conclusão')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "observacao_decisao"
    }
  }, [_vm._v("Observação:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.observacao),
      expression: "nota.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_decisao",
      "id": "observacao_decisao",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nota.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "observacao", $event.target.value)
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "Revisão",
      "disabled": _vm.ehVisualizacao || (_vm._.includes(['PAGAMENTO', 'RESSARCIMENTO', 'PRESTACAO_DE_CONTAS'], this.processo) && ((_vm.projeto.Status_ERP !== 'APR' && _vm.possuiNotaSapiens) || _vm.tituloMovimentado))
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Revisão")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Revisão")
      }
    }
  }), _vm._v(" Encaminhar para revisão da entidade\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), (_vm._.includes(['PAGAMENTO', 'RESSARCIMENTO', 'PRESTACAO_DE_CONTAS'], this.processo)) ? _c('div', [(_vm.projeto.Status_ERP !== 'APR' && _vm.possuiNotaSapiens) ? _c('p', {
    staticClass: "col-md-12 text-danger"
  }, [_c('strong', [_vm._v(" Atenção:")]), _vm._v(" Não é possível devolver para a entidade pois o projeto está com status diferente de APR e com nota no Sapiens.")]) : _vm._e(), _vm._v(" "), (_vm.tituloMovimentado) ? _c('p', {
    staticClass: "col-md-12 text-danger"
  }, [_c('strong', [_vm._v(" Atenção:")]), _vm._v(" Não é possível devolver para a entidade pois a nota possui movimento contábil.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group required-field full col-md-12",
    class: {
      'has-error': _vm.errors.first('motivo de devolucao')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivosDevolucao,
      "multiple": false,
      "close-on-select": true,
      "placeholder": "Selecione um motivo de Devolução para a entidade",
      "custom-label": _vm.motivoDevolucaoDescricao,
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "motivo de devolucao",
      "data-vv-as": "motivo de devolucao",
      "option-height": 30,
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.motivoDevolucao),
      callback: function($$v) {
        _vm.motivoDevolucao = $$v
      },
      expression: "motivoDevolucao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.aprovacao.resultadoAprovacao === 'Revisão' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_revisão"
    }
  }, [_vm._v("Motivo para revisão:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.observacao),
      expression: "nota.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "motivo para revisão",
      "rows": "3",
      "id": "justificativa_revisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nota.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "Análise",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise")
      }
    }
  }), _vm._v(" Retornar para análise\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa reanalise')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_reanalise"
    }
  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.observacao),
      expression: "nota.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa reanalise",
      "rows": "3",
      "id": "justificativa_reanalise",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nota.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Autorização'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aprovacao.resultadoAprovacao),
      expression: "aprovacao.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "Análise Tributária",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.aprovacao.resultadoAprovacao, "Análise Tributária")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.aprovacao, "resultadoAprovacao", "Análise Tributária")
      }
    }
  }), _vm._v(" Retornar para Análise Tributária\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.aprovacao.resultadoAprovacao === 'Análise Tributária' && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa encaminhar analise tributaria')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_reanalise"
    }
  }, [_vm._v("Motivo para devolver para Análise Tributária:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.observacao),
      expression: "nota.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa reanalise",
      "rows": "3",
      "id": "justificativa_encaminhar_analise_tributaria",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.nota.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa encaminhar analise tributaria')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa encaminhar analise tributaria')))]) : _vm._e()]) : _vm._e()])]) : _vm._e()])])]), _vm._v(" "), (_vm._.includes(['Análise', 'Análise Tributária', 'Autorização', 'Liquidação'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.loading.suportesFbbAtivos) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando Supotes não encerrados...")]) : _c('span', [_c('multiselect', {
    attrs: {
      "options": _vm.listaSuportes,
      "multiple": true,
      "max": 3,
      "close-on-select": true,
      "placeholder": 'Neste id ' + _vm.id + ' pode ter vinculado opcionalmente de um a três Suportes desta lista de chamados não encerrados',
      "custom-label": _vm.suporteNome,
      "track-by": "numero",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "suporte_fbb",
      "data-vv-as": "suporte_fbb",
      "disabled": _vm.ehVisualizacao
    },
    scopedSlots: _vm._u([{
      key: "maxElements",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-red"
        }, [_vm._v("Já escolheu o limite de três suportes que pode vincular a este ID")])]
      }
    }], null, false, 1318475097),
    model: {
      value: (_vm.nota.suporteFbb),
      callback: function($$v) {
        _vm.$set(_vm.nota, "suporteFbb", $$v)
      },
      expression: "nota.suporteFbb"
    }
  })], 1)])])]) : _vm._e()])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Nome")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Final do Mandato")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Ocorrência")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Data")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Observação")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Situação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v("Não há ocorrências ativas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Nota Fiscal Eletrônica")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dados do Documento")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Fornecedor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label col-md-4",
    staticStyle: {
      "color": "#FF9900"
    }
  }, [_c('strong', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticStyle: {
      "color": "#FF9900"
    }
  }, [_vm._v("Caso as informações bancárias do fornecedor "), _c('strong', [_vm._v("não sejam encontradas ")]), _vm._v(" no menu acima, preencha os dados ao lado para cadastrar uma nova conta. Se houver agências/contas iguais com "), _c('strong', [_vm._v("digitos diferentes")]), _vm._v(", favor atentar ao escolher a opção correta. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "control-label col-md-4"
  }, [_vm._v("OBS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('span', {
    staticStyle: {
      "color": "#1565C0",
      "font-weight": "bold"
    }
  }, [_vm._v("Favor atentar para que os dados bancários sejam da mesma titularidade do CPF/CNPJ informado no quadro anterior (Fornecedor), caso contrário o pagamento será devolvido.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Solicitado Fundação BB")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Pendente Fundação BB")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Solicitado Parceiros Estratégicos")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Pendente Parceiros Estratégicos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total de adiantamento solicitado")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_c('span', [_vm._v("Total Pendente de Prestação de contas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Item")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Transação")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("ISS")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("COFINS")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("PIS")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("CSLL")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("IRRF")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("INSS")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Outros")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Itens da NF-e")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ordem")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Qtde")]), _vm._v(" "), _c('th', [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Quantidade de itens")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total desta NF-e")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Registros")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Famílias")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Participantes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', {
    staticClass: "centralizado",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Conta Interna do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Outras Informações")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Banco")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Agência")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Conta")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("MCI")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Conta Movimento")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado borda"
  }, [_vm._v("Tipo do Projeto")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Anexos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico Antigo")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Observação Opcional")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Decisão")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6cd25eef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/pagamento/EditaPagamento.vue
// module id = 1898
// module chunks = 2